import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import AdminLayout from "../../layout/AdminLayout";
import { useAuth } from "../../../context/AuthContext";
import * as model from "../../../models/ReportsModel";
import { useNotificationCount } from "../../../context/NotificationCountContext";
import ReportTable from "./ReportTable";
import { ConfirmDelete } from "../../modals/ConfirmDelete";
import { apiError } from "../../../helpers/ErrorHelper";
import { toast } from "react-toastify";
import PageHeader from "../../common/PageHeader";
import config from "../../../config/config";
import { MyReactSelect, MyReactSelectMultiple } from "../../inputs/inputs";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
//import { RequirementView } from "./RequirementView";

export default function Reports() {
    const module = {
        title: 'Reports',
        singularTitle: 'Report',
        key: 'reports',
        route: 'client-report',
        primaryCol: '_requirement_id'
    };

    const { state } = useAuth();
    let user_data = state.user_data;
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();
    const [candidateStatuses, setCandidateStatuses] = useState([]);
    const [isTrash, setIsTrash] = useState(false);

    const [listData, setListData] = useState([]);
    const [cacheTime, setCacheTime] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [months, setMonths] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(null);

    useEffect(() => {
        fetchMonths();
        // Initial fetch for the current month
        //console.log("Fetching months =>", months);
        //fetchData(limit, page);
    }, []);

    const fetchMonths = async () => {
        try {
            let apiParam = {
                user_token: user_data.user_token,
            };
            const response = await model.getMonthsList(apiParam);
            if (typeof response == typeof undefined) {
                navigate("/re-login");
                return;
            }
            //console.log("Months response =>", response.months);
            setMonths(response.months);
            // Set current month as default
            const currentMonth = new Date().toISOString().slice(0, 7); // e.g. "2025-08"
            const defaultMonth = response.months.find(m => m.value === currentMonth);
            setSelectedMonth(defaultMonth || response.months[0]);

            // Fetch data after setting the month
            fetchData(defaultMonth?.value || response.months[0]?.value);
        } catch (error) {
            console.error(error);
        }
    }

    const fetchData = async (month) => {
        setLoading(true);
        console.log("Fetching report for month:", month);
        try {
            let apiParam = {
                month: month,
                user_token: user_data.user_token,
            };
            const response = await model.getReport(apiParam);
            if (typeof response == typeof undefined) {
                navigate("/re-login");
                return;
            }

            setListData(response[module.key]);
            setTotalRows(response.pagination.total_rows);
            //setLimit(newLimit);
            //setPage(page);
            setCandidateStatuses(response.candidate_status_list || []);

            if (response.time) {
                setCacheTime(response.time);
            }

            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    const exportToExcel = async () => {

        if (!listData || listData.length === 0) {
            toast.warning("No data to export");
            return;
        }

        // Generate timestamp (YYYYMMDD_HHMMSS + random 4 digits)
        const timestamp = new Date().toISOString()
                                    .replace(/[-:T]/g, "") // remove special chars
                                    .split(".")[0];        // remove milliseconds

        const fileName = `Client_Report_${timestamp}.xlsx`;
        console.log("Generated File:", fileName);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Client Report");

        // Base columns
        let baseColumns = [
            { header: "Client Name", key: "client_name_with_gstin" },
            { header: "Active Positions", key: "active_positions" },
            { header: "On Hold", key: "on_hold_positions" },
            { header: "Closed", key: "closed_positions" },
            { header: "Total Submissions", key: "total_submissions" },
            { header: "Total Interviews", key: "total_interviews" },
            { header: "No Shows", key: "no_show_count" },
        ];

        // Add dynamic columns for candidateStatuses
        let statusColumns = candidateStatuses.map(status => ({
            header: status.status_name,
            key: `status_name_${status._status_id}`,
        }));

        worksheet.columns = [...baseColumns, ...statusColumns];

        // Add rows
        listData.forEach(row => {
            let rowData = {
                client_name_with_gstin: row.client_name_with_gstin,
                active_positions: Number(row.active_positions) || 0,
                on_hold_positions: Number(row.on_hold_positions) || 0,
                closed_positions: Number(row.closed_positions) || 0,
                total_submissions: Number(row.total_submissions) || 0,
                total_interviews: Number(row.total_interviews) || 0,
                no_show_count: Number(row.no_show_count) || 0,
            };

            // Add dynamic status counts if available
            candidateStatuses.forEach(status => {
                rowData[`status_name_${status._status_id}`] =
                    Number(row[`status_name_${status._status_id}`]) || 0;
            });

            worksheet.addRow(rowData);
        });

        // Style header row
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'D9E1F2' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        // Generate Excel file and save
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName);
    };

    return (
        <AdminLayout>
            <Helmet>
                <title>{module.title} - Digital CMS</title>
            </Helmet>
<style>
{`
    .rdt_TableHead {
        z-index: 2 !important; /* stay above body rows */
        position: sticky !important;
    }
    .cwjuei {
        position: sticky !important;
    }
`}
</style>
            <div className="main-content app-content">
                <div className="container-fluid">
                    <PageHeader module={module} isTrash={isTrash}  />
                    <div className="row">
                        <div className="col-xl-12">
                            
                            <div className="card custom-card">
                            {/* {listData.length > 0 && (
                                <div className="col-xl-6 mt-4 mx-2">
                                    <button className="btn btn-primary ms-3" onClick={exportToExcel}>Download Excel</button>
                                </div>
                            )} */}
                            <div className="row">
                            {Array.isArray(months) && months.length > 0 && selectedMonth ? (
                        <div className="mb-3 my-3 ms-3" style={{ maxWidth: 300 }}>
                            <select
                                className="form-select"
                                value={selectedMonth.value}
                                onChange={(e) => {
                                    const selected = months.find(m => m.value === e.target.value);
                                    setSelectedMonth(selected);
                                    fetchData(selected.value);
                                }}
                            >
                                {months.map((month) => (
                                    <option key={month.value} value={month.value}>
                                        {month.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        <div className="mb-3" style={{ maxWidth: 300 }}>
                            <div className="form-control">Loading months...</div>
                        </div>
                    )}
                    {listData.length > 0 && (
                        <div className="col-xl-6 mt-3 ">
                            <button className="btn btn-primary ms-3" onClick={exportToExcel}>Download Excel</button>
                        </div>
                    )}
                    </div>
                                <div className="card-body">
                                    
                                    <div className="table-responsive">
                                        <ReportTable
                                            module={module}
                                            data={listData}
                                            loading={loading}
                                            totalRows={totalRows}
                                            // fetchData={fetchData}
                                            candidateStatuses={candidateStatuses}
                                            // isTrash={isTrash}
                                            // limit={limit}
                                            // page={page}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Helmet></Helmet>
        </AdminLayout>
    );
}
